// Google Analytics event tracking utilities

/**
 * Track a custom event
 */
export const trackEvent = (
  eventName: string,
  eventParams?: {
    [key: string]: any;
  }
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track form submission
 */
export const trackFormSubmission = (formName: string, formType?: string) => {
  trackEvent('form_submission', {
    form_name: formName,
    form_type: formType,
  });
};

/**
 * Track newsletter signup
 */
export const trackNewsletterSignup = (method: string = 'email') => {
  trackEvent('newsletter_signup', {
    method,
  });
};

/**
 * Track button click
 */
export const trackButtonClick = (buttonName: string, pageLocation?: string) => {
  trackEvent('cta_click', {
    button_name: buttonName,
    page_location: pageLocation || (typeof window !== 'undefined' ? window.location.pathname : ''),
  });
};

/**
 * Track page view (automatically handled by Next.js, but can be used manually)
 */
export const trackPageView = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.NEXT_PUBLIC_GA_ID as string, {
      page_path: url,
    });
  }
};

/**
 * Track contact method selection
 */
export const trackContactMethod = (method: 'phone' | 'email' | 'whatsapp') => {
  trackEvent('contact_method_selected', {
    method,
  });
};

/**
 * Track service inquiry
 */
export const trackServiceInquiry = (serviceType: string) => {
  trackEvent('service_inquiry', {
    service_type: serviceType,
  });
};
